/**
 * Prazos do Instagram, na fonte única que servidor e cliente enxergam.
 *
 * Os três números são regra da Meta, não escolha nossa, e apareciam copiados em
 * `server/services/instagram.service.ts` e na tela de comentários. Uma cópia
 * divergindo produz o pior tipo de erro deste módulo: a tela dizendo que dá
 * para responder quando a Meta já recusa, ou escondendo o botão de quem ainda
 * podia ser atendido — nos dois casos sem nada no log.
 */

/** Janela padrão de resposta a uma mensagem direta: 24 horas. */
export const IG_WINDOW_MS = 24 * 60 * 60 * 1000;

/**
 * Janela estendida da tag HUMAN_AGENT: 7 dias.
 *
 * Só vale para conta com a permissão aprovada em App Review, e a tag só pode
 * ser usada DEPOIS que as 24h padrão fecharam.
 */
export const IG_HUMAN_AGENT_WINDOW_MS = 7 * 24 * 60 * 60 * 1000;

/**
 * Prazo para responder em privado a um comentário: 7 dias desde o comentário.
 *
 * Independente das janelas acima, e válido uma única vez por comentário.
 */
export const IG_PRIVATE_REPLY_WINDOW_MS = 7 * 24 * 60 * 60 * 1000;
